module.exports = __webpack_public_path__ + "icon_add_almacen.png";